package kz.dentalcrm.app.domain

import kotlinx.datetime.LocalDate
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.request_model.AppointmentRequest
import kz.dentalcrm.app.data.network.response_model.AppointmentResponse
import kz.dentalcrm.app.data.network.response_model.CashBox
import kz.dentalcrm.app.data.network.response_model.PatientData
import kz.dentalcrm.app.data.network.response_model.PatientTreatment
import kz.dentalcrm.app.data.network.response_model.PatientsResponse
import kz.dentalcrm.app.data.network.response_model.employees.EmployeesResponse

interface AppointmentRepository {

    suspend fun getAppointments(
        dateFrom: LocalDate,
        dateTo: LocalDate,
        employeeId: String? = null
    ): Result<List<AppointmentResponse>>

    suspend fun addPatient(
        name: String,
        surname: String,
        phone: String,
    ): Result<PatientData?>

    suspend fun getPatients(
        page: Int = 0,
    ): Result<PatientsResponse?>

    suspend fun getPatient(
        id: Int = 0
    ): Result<PatientData?>

    suspend fun searchPatientByFilter(
        name: String,
        surname: String,
        phone: String,
    ): Result<PatientsResponse?>

    suspend fun searchPatients(
        search: String,
        page: Int = 1,
    ): Result<PatientsResponse>

    suspend fun getEmployees(
        page: Int = 0,
        pageSize: Int = 0
    ): Result<EmployeesResponse?>

    suspend fun searchEmployees(
        page: Int = 0,
        search: String,
    )

    suspend fun createAppointment(
        appointmentRequest: AppointmentRequest
    ): Result<Any?>

    suspend fun deleteAppointment(
        id: Int
    ): Result<Any?>

    suspend fun updatePatient(
        patientData: PatientData
    ): Result<Any?>

    suspend fun deletePatient(
        id: Int
    ): Result<Any?>

    suspend fun getPositions(): Result<List<kz.dentalcrm.app.data.network.response_model.employees.Position>>

    suspend fun getServicesArray(): Result<List<kz.dentalcrm.app.data.network.response_model.services.Service>>

    suspend fun addEmployee(
        employeeBody: kz.dentalcrm.app.data.network.request_model.AddEmployeeBody
    ): Result<Any?>

    suspend fun getPermissions(): Result<List<kz.dentalcrm.app.data.network.response_model.permissions.Permission>>

    suspend fun getEmployee(id: Int): Result<kz.dentalcrm.app.data.network.response_model.employees.Employee?>

    suspend fun deleteEmployee(id: Int): Result<Any?>

    suspend fun updateEmployee(id: Int, employeeBody: kz.dentalcrm.app.data.network.request_model.AddEmployeeBody): Result<Any?>

    suspend fun getAppointment(id: Int): Result<AppointmentResponse?>

    suspend fun updateAppointment(id: Int, appointmentRequest: AppointmentRequest): Result<Any?>

    suspend fun getCashBoxes(): Result<List<CashBox>>

    suspend fun getAppointmentTreatments(appointmentId: Int): Result<List<PatientTreatment>>

    suspend fun getPatientLastAppointments(patientId: Int): Result<List<AppointmentResponse>>
}